import TooltipTag from "./TooltipTag";
import { Typography } from "antd";
import { getMappingValue } from "../../utils/tableConfigs/GlobalFunctions";

interface StatusPillProps {
  text?: string | number | null;
  textColor?: Record<string, string>;
  pillColor?: Record<string, string>;
  tooltipTitle?: Record<string, string>;
  type?: string;
}

export default function StatusPill({
  text,
  textColor,
  pillColor,
  tooltipTitle,
  type,
}: StatusPillProps) {
  if (text == null) {
    return "";
  }

  const pillColorValue = getMappingValue(pillColor, text);
  const tooltipTitleValue = getMappingValue(tooltipTitle, text);
  const textColorValue = getMappingValue(textColor, text);

  if (pillColorValue) {
    return (
      <TooltipTag
        tooltipTitle={tooltipTitleValue}
        tagColor={pillColorValue}
        textColor={textColorValue}
      >
        {text}
      </TooltipTag>
    );
  }

  if (type === "float") {
    const number = parseFloat(text as string);
    return Number.isFinite(number) ? number.toFixed(2) : "-";
  }
  if (String(text).length > 100) {
    return (
      <Typography.Paragraph ellipsis={{ tooltip: text, rows: 3 }}>
        {text}
      </Typography.Paragraph>
    );
  }
  return text;
}
